// extracted by css-extract-rspack-plugin
export default {"scrollMarksContainer":"ScrollMarksContainer-module__scrollMarksContainer__Eu7uU"};